// extracted by mini-css-extract-plugin
export default {"container":"container--zOTa5","scroller":"scroller--ao0Op","item":"item--XuSYj"};